/**
 * Nonce automático en peticiones a pos-ajax.php.
 */

export function initAjaxSecurityPrefilter(win, $) {
	const posNonce = win.posNonce;
	if (!posNonce) return;
	$.ajaxPrefilter((options) => {
		const url = options.url || '';
		if (url.indexOf('pos-ajax.php') === -1) return;
		if (typeof options.data === 'string') {
			if (options.data.indexOf('nonce=') === -1) {
				options.data += `${options.data ? '&' : ''}nonce=${encodeURIComponent(posNonce)}`;
			}
		} else if (options.data && typeof options.data === 'object') {
			if (!Array.isArray(options.data) && !options.data.nonce) {
				options.data.nonce = posNonce;
			}
		} else {
			options.data = { nonce: posNonce };
		}
	});
}
